import AlYusrAxiosApiInstance, {AxiosSearchParams} from "../axios/alYusrAxiosApiInstance";
import {
  DeleteTransactionRequestModel,
  LookupItemModel,
  ResponseBaseModel,
  RestaurantResponseModel,
  RowStateEnum,
  SearchReservedTransactionResponseModel,
  SearchTransactionRequestModel,
  SearchTransactionsParams,
  TransactionDetailResponseModel, TransactionDueDetailResponseModel,
  TransactionResponseModel,
  TransactionResultResponseModel,
  TransactionServerResponseModel,
  ValidateTransactionModeEnum,
} from "../models";
import {
  convertDateToLocalIsoDate,
  getUserDefaultBranchId,
  getUserId,
  getUserStationId,
  handleError,
  removeUtcOffset
} from "../utils";
import {AlYuserApiUrls} from "../configuration";
import {createQueryString, filterSearchParams} from "../utils/querySearch/parseSearchParams";
//#region get
export const validateTransactionEligibilityByAction = async ({
                                            transactionId,
                                            creationDate,
                                            totalTax,
                                            mode,
                                          }: {
  transactionId: number;
  creationDate: Date;
  totalTax: number;
  mode: ValidateTransactionModeEnum;
}): Promise<ResponseBaseModel<boolean>> => {
  let response: ResponseBaseModel<boolean>;
  let url: string = "";
  switch (mode) {
    case ValidateTransactionModeEnum.Modify:
      url = `${
        AlYuserApiUrls.transactionController.validateEditTransactionUrl
      }?transactionId=${transactionId}&userId=${getUserId()}&transactionCreatedDate=${creationDate}&totalTax=${totalTax}`;
      break;
    case ValidateTransactionModeEnum.Delete:
      url = `${
        AlYuserApiUrls.transactionController.validateDeleteTransactionUrl
      }?transactionId=${transactionId}&userId=${getUserId()}`;
      break;
    case ValidateTransactionModeEnum.Return:
      url = `${
        AlYuserApiUrls.transactionController.validateReturnTransactionUrl
      }?transactionId=${transactionId}&userId=${getUserId()}`;
      break;
    // case ValidateTransactionModeEnum.Payment:
    //   url = `${
    //       AlYuserApiUrls.transactionController.validateTransactionEligibilityForPaymentUrl
    //   }?transactionId=${transactionId}`;
    //   break;
  }
  response = await AlYusrAxiosApiInstance.get(url);
  return response;
};
export const validateTransactionEligibilityForPayment = async (transactionId: number): Promise<ResponseBaseModel<TransactionDueDetailResponseModel>> => {
  return await AlYusrAxiosApiInstance.get(
      `${AlYuserApiUrls.transactionController.validateTransactionEligibilityForPaymentUrl}?transactionId=${transactionId}`
  );
}
export const searchTransactions = async (
  request: SearchTransactionRequestModel
): Promise<ResponseBaseModel<TransactionResponseModel[]>> => {
  let response: ResponseBaseModel<TransactionResponseModel[]> = {
    PageCount: 0,
    TotalRecoredCount: 0,
  };
  const fetchResult: ResponseBaseModel<TransactionServerResponseModel[]> = await AlYusrAxiosApiInstance.get(
      AlYuserApiUrls.transactionController.searchTransactionUrl,
      { params: AxiosSearchParams(request, "searchParm") }
  );

  // let url: string = `${
  //   AlYuserApiUrls.transactionController.searchTransactionUrl
  // }?searchparm.pageNumber=${request.pageNumber}&&searchparm.pageSize=${
  //   request.pageSize
  // }&&searchparm.transactionType=${Number(request.transactionType)}`;
  // url = request.customerId
  //   ? `${url}&searchparm.customerId=${request.customerId}`
  //   : url;
  // url = request.searchValue
  //   ? `${url}&searchparm.iD=${request.searchValue}`
  //   : url;
  // const fetchResult: ResponseBaseModel<TransactionServerResponseModel[]> =
  //   await AlYusrAxiosApiInstance.get(url);
  response.Errors = fetchResult.Errors;
  response.TotalRecoredCount = fetchResult.TotalRecoredCount;
  if (
    fetchResult.Result !== null &&
    fetchResult.Result !== undefined &&
    fetchResult.Result.length !== 0
  ) {

    response.Result = [];
    fetchResult.Result.forEach((row) => {
      response.Result?.push({
        id: row.ID,
        code: row.Code,
        date:row.Date,
        serial: row.Serial,
        customerNameAr: row.CustomerNameAr,
        customerNameEn: row.CustomerNameEn,
        employeeNameAr: row.EmployeeNameAr,
        employeeNameEn: row.EmployeeNameEn,
        paymentTypeNameAr: row.PaymenTypeNameAr,
        paymentTypeNameEn: row.PaymenTypeNameEn,
        costCenterNameAr: row.CostCenterNameAr,
        costCenterNameEn: row.CostCenterNameEn,
        calcTypeNameAr: row.CalcTypeNameAr,
        calcTypeNameEn: row.CalcTypeNameEn,
        currencyNameAr: row.CurrencyNameAr,
        currencyNameEn: row.CurrencyNameEn,
        totalMoney: row.TotalMoney??null,
        discount: row.Discount,
        cashMoney: row.CashMoney,
        cardMoney: row.CardMoney,
        delayMoney: row.DelayMoney,
        othersMoney: row.OthersMoney,
        moneyAdd: row.MoneyAdd,
        transportCost: row.TransportCost,
        tobaccoValue: row.TobaccoValue??null,
        extraAmountPaid: row.ExtraAmountPaid,
        totalAdditionalCostValue: row.TotalAdditionalCostValue??null,
        totalServiceTax: row.TotalServiceTax??null,
        totalCost: row.TotalCost,
        netMoney: row.NetMoney,
        valueCurrency: row.ValueCurrency,
        dueDate: row.DueDate,
        confirmed: row.Confirmed,
        creationDate: row.CreateDate,
        taxPercentage: row.TaxPercentage??null,
        transactionType: row.TransactionType,
        totalTax: row.TotalTax,
        isValidForReturn: row.IsValidForReturn,
        isEnablePay:row.IsEnablePay,
        amountPaid:row.Amount_Paid??0,
        amountDue:row.Amount_Due??0,
        isPaid:row.IsPaid??false,
        isValidToUseAsTransaction:row.IsValidToUseAsTransaction??false,
        isValidToUseAsSource:row.IsValidToUseAsSource??false,
      });
    });
  }
  return response;
};
export const getTransactionDetailForRefund = async (
  id: number
): Promise<ResponseBaseModel<TransactionDetailResponseModel> | null> => {
  let response: ResponseBaseModel<TransactionDetailResponseModel>;
  let url: string = `${
    AlYuserApiUrls.transactionController.getTransactionForReturnByIdUrl
  }?transactionId=${id}&userId=${getUserId()}`;
  response = await AlYusrAxiosApiInstance.get(url);
  if (response && response.Result && response.Result.TransactionDetaillist) {
    response.Result.TransactionDetaillist.forEach((item) => {
      item.defaultQuantity = item.Quantity;
    });
    return response;
  }
  return null;
};
export const getTransactionAsSource = async (
    id: number
): Promise<ResponseBaseModel<TransactionDetailResponseModel> | null> => {
  let response: ResponseBaseModel<TransactionDetailResponseModel>;
  let url: string = `${
      AlYuserApiUrls.transactionController.getTransactionAsSource
  }?transactionId=${id}&userId=${getUserId()}`;
  response = await AlYusrAxiosApiInstance.get(url);
  if (response && response.Result && response.Result.TransactionDetaillist) {
    response.Result.TransactionDetaillist.forEach((item) => {
      item.defaultQuantity = item.Quantity;
    });
    return response;
  }
  return null;
};
export const getTransactionDetail = async (
  id: number
): Promise< ResponseBaseModel<TransactionDetailResponseModel>> => {
  return  await AlYusrAxiosApiInstance.get(`${AlYuserApiUrls.transactionController.getFullTransactionByIdUrl}?id=${id}`);};
export const getTransactionFullInfoById = async (
  id: number
): Promise<TransactionDetailResponseModel | null> => {
  let response: ResponseBaseModel<TransactionDetailResponseModel>;
  let url: string = `${AlYuserApiUrls.transactionController.getTransactionFullInfoByIdUrl}?transactionHeaderID=${id}`;
  response = await AlYusrAxiosApiInstance.get(url);
  return response !== null &&
    response !== undefined &&
    response.Result !== null &&
    response.Result !== undefined
    ? response.Result
    : null;
};
//#endregion
//#region post
export const deleteTransaction = async (
  request: DeleteTransactionRequestModel
): Promise<ResponseBaseModel<boolean>> => {
  let response: ResponseBaseModel<boolean> = {};
  let url: string = `${AlYuserApiUrls.transactionController.deleteTransactionUrl}`;
  try {
    response = await AlYusrAxiosApiInstance.post(url, request);
  } catch (err) {
    alert(handleError(err));
  }
  return response;
};


export const saveTransaction = async (
  request: TransactionDetailResponseModel
): Promise<ResponseBaseModel<TransactionResultResponseModel>> => {
  let response: ResponseBaseModel<TransactionResultResponseModel> = {};
  try {
    request = prepareTransactionBasicData(request);
    request.Date = convertDateToLocalIsoDate(request.Date)??new Date();
    request.DueDate= convertDateToLocalIsoDate(request.DueDate);
    response = await AlYusrAxiosApiInstance.post(
      AlYuserApiUrls.transactionController.saveTransactionUrl, request);
  } catch (err) {
    alert(handleError(err));
  }
  return response;
};

export const cancelReservation = async (transactionId: number, userId: number, reason?: string) => {
   let response: ResponseBaseModel<TransactionResultResponseModel> = {};
  try {
    response = await AlYusrAxiosApiInstance.post(
      `${AlYuserApiUrls.transactionController.cancelReservation}?transactionId=${transactionId}&userId=${userId}&reason=${reason}`
    );
  } catch (err) {
    alert(handleError(err));
  }
  return response;
}

export const searchReservedTransactions = async (searchParams: SearchTransactionsParams) => {
   let response: ResponseBaseModel<SearchReservedTransactionResponseModel[]> = {};
  try {
    const filteredSearchParams = filterSearchParams(searchParams);
    const searchQuery = createQueryString(filteredSearchParams);
    response = await AlYusrAxiosApiInstance.get(
      `${AlYuserApiUrls.transactionController.searchReservedTransactions}?${searchQuery}`
    );
  } catch (err) {
    alert(handleError(err));
  }
  return {result:  response.Result as SearchReservedTransactionResponseModel[], totalCount: response.TotalRecoredCount};
}

export const getreservedTransactionByID = async (reservedTransactionId: number) => {
   let response: ResponseBaseModel<SearchReservedTransactionResponseModel[]> = {};
  try {
    response = await AlYusrAxiosApiInstance.get(
      `${AlYuserApiUrls.transactionController.getReservedTransactionByID}?reservedTransactionId=${reservedTransactionId}`
    );
  } catch (err) {
    alert(handleError(err));
  }
  return response.Result;
}

export const getChildrenTables = async (parentID: number): Promise<LookupItemModel[]> => {
    let categoryResult: ResponseBaseModel<RestaurantResponseModel[]>;
    let response: LookupItemModel[] = [];
    const url: string = `${AlYuserApiUrls.restaurantTableController.getAllRestuarntTableByParentId}?parentId=${parentID}`;
    categoryResult = await AlYusrAxiosApiInstance.get(url);
    if (
        categoryResult !== null &&
        categoryResult.Result !== null &&
        categoryResult.Result !== undefined &&
        categoryResult.Result.length !== 0
    ) {
        categoryResult.Result.forEach((row) => {
            response.push({
                nameAr: row.Name,
                name: row.Name_En,
                value: row.ID.toString(),
                otherValue: {
                    Active: row.Active,
                    IsPrinted: row.IsPrinted
                }
            });
        });
    }
    return response;
};
//#endregion
//#region private
const prepareTransactionBasicData = (
    request: TransactionDetailResponseModel
): TransactionDetailResponseModel => {
  const isAddState = request.rowState === Number(RowStateEnum.Add);
  const isUpdateState = request.rowState === Number(RowStateEnum.Update);

  const assignDefault = (value: number | null, defaultValue: number): number =>
      value == 0 || value == null ? defaultValue : value;
  return {
    ...request,

    Branch_ID: getUserDefaultBranchId()??0,
    Station_ID: assignDefault(request.Station_ID, getUserStationId()),
    CreatedBy: isAddState ? assignDefault(request.CreatedBy, getUserId()) : request.CreatedBy,
    User_Create: isAddState ?  assignDefault(request.User_Create, getUserId()) : request.User_Create,
    ModifiedBy: isUpdateState ? assignDefault(request.ModifiedBy, getUserId()) : request.ModifiedBy,
    User_Update: isUpdateState ? assignDefault(request.User_Update, getUserId()) : request.User_Update,
    //@ts-ignore
    Date:removeUtcOffset(request.Date),
  };
};
//#endregion
